import React, { useState, useEffect } from "react";
import {
    Modal,
    Input,
    Button,
    Form,
    Select,
    InputNumber,
    message,
    Radio,
    DatePicker,

} from "antd";
import dayjs from "dayjs";
import { useFetchListInput } from "../../Input/hooks/useFetch";
import TableMapInput from "./TableMapInput";
const { RangePicker } = DatePicker;

const MapinputModal = ({ visible, onClose, record, refetch ,handleMapEdit}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [historyDateFilter, setHistoryDateFilter] = useState([dayjs(), dayjs()]);
    const [historySearchText, setHistorySearchText] = useState("");
    const [listInputData, setListInputData] = useState([]);
    const { mutateAsync: listInput, isLoading: caseDataLoading } = useFetchListInput();


    const handleMapComfirm = (payload) => {
        handleMapEdit(payload)
        form.resetFields();
        setListInputData([])
        setHistoryDateFilter([dayjs(), dayjs()])
        setHistorySearchText("")
        onClose();
    };

    const handleCancel = () => {
        form.resetFields();
        setListInputData([])
        setHistoryDateFilter([dayjs(), dayjs()])
        setHistorySearchText("")
        onClose();
    };

    const handleSearch = async () => {
        let startDate = historyDateFilter[0].format('YYYY-MM-DD');
        let endDate = historyDateFilter[1].format('YYYY-MM-DD');
        const payload = {
            startDate,
            endDate,
            search: historySearchText,
        };
        const result = await listInput(payload);
        if (result?.result && result?.result.length > 0) {
            setListInputData(result?.result);
        } else setListInputData([]);
    };


    return (
        <Modal
            title="แก้ไขข้อมูล"
            open={visible}
            onCancel={handleCancel}
            loading={caseDataLoading}
            footer={null}
            width="90%"
            style={{ top: 20, maxWidth: "100vw", overflowY: "auto", maxHeight: "90%" }}
            zIndex={2000}
        >
            <div className="mb-4 flex gap-3">
                <RangePicker
                    placeholder="Date"
                    value={historyDateFilter}
                    onChange={(date) => setHistoryDateFilter(date)}
                    allowClear
                    className="w-64"
                    format="DD/MM/YYYY"
                />
                <Input
                    placeholder="Search"
                    value={historySearchText}
                    onChange={(e) => setHistorySearchText(e.target.value)}
                    allowClear
                    className="w-32"
                />
                <Button type="primary" onClick={handleSearch}>Search</Button>
                
            </div>
            <TableMapInput  
                data={listInputData}
                onEdit={handleMapComfirm}
                //onDelete={handleDelete}
                //onRejectCancel={handleRejectCancel}
                loading={caseDataLoading}
                isHistory={true}
                bordered
                scroll={{ x: 'max-content' }}
                auditRecord={record}
                refetch={refetch}
            />
        </Modal>

    );
};

export default MapinputModal;
